(function () {
  if (window.__nhHome) return; window.__nhHome = true;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(root) {
    if (root.__nh) return; root.__nh = true;
    var slides = [].slice.call(root.querySelectorAll('.nh-slide'));
    var pgs = [].slice.call(root.querySelectorAll('.nh-pg'));
    var count = root.querySelector('.nh-count');
    var dur = (parseInt(root.dataset.autoplay, 10) || 5) * 1000;
    var i = 0, t = null, paused = false;
    function warm(k) {
      var s = slides[(k + slides.length) % slides.length]; if (!s) return;
      s.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
    }
    function visibleVideo(s) {
      var vs = [].slice.call(s.querySelectorAll('video'));
      for (var k = 0; k < vs.length; k++) { if (vs[k].offsetParent !== null) return vs[k]; }
      return vs[0] || null;
    }
    function slideDur(s) {
      var v = visibleVideo(s);
      if (v && isFinite(v.duration) && v.duration > 0) return Math.max(dur, Math.min(v.duration * 1000, 20000));
      return dur;
    }
    function vids(on) {
      slides.forEach(function (s, k) {
        s.querySelectorAll('video').forEach(function (v) {
          v.muted = true;
          if (k === on) { try { v.currentTime = 0; } catch (e) {} var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
        });
      });
    }
    function show(n) {
      i = (n + slides.length) % slides.length;
      warm(i); warm(i + 1); warm(i - 1);
      var d = slideDur(slides[i]);
      root.style.setProperty('--nh-dur', d / 1000 + 's');
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      pgs.forEach(function (p, k) { p.classList.remove('is-on'); p.classList.toggle('is-done', k < i); void p.offsetWidth; if (k === i) p.classList.add('is-on'); });
      if (count) count.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      vids(i); arm(d);
    }
    function arm(d) { clearTimeout(t); if (!paused && slides.length > 1) t = setTimeout(function () { show(i + 1); }, d || slideDur(slides[i])); }
    var pv = root.querySelector('[data-nh="prev"]'), nx = root.querySelector('[data-nh="next"]');
    if (pv) pv.addEventListener('click', function () { show(i - 1); });
    if (nx) nx.addEventListener('click', function () { show(i + 1); });
    pgs.forEach(function (p, k) { p.addEventListener('click', function () { show(k); }); });
    var pb = root.querySelector('[data-nh="pause"]');
    if (pb) pb.addEventListener('click', function () {
      paused = !paused; root.classList.toggle('is-paused', paused);
      pb.setAttribute('aria-pressed', paused ? 'true' : 'false');
      pb.innerHTML = paused ? pb.dataset.play : pb.dataset.pause;
      if (paused) clearTimeout(t); else arm();
    });
    var x0 = null;
    root.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
    root.addEventListener('pointerup', function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 50) show(dx < 0 ? i + 1 : i - 1); });
    var first = visibleVideo(slides[0]);
    if (first && !(first.readyState >= 1)) first.addEventListener('loadedmetadata', function () { if (i === 0) { root.style.setProperty('--nh-dur', slideDur(slides[0]) / 1000 + 's'); arm(); } }, { once: true });
    if (RM) { paused = true; root.classList.add('is-paused'); }
    show(0);
  }

  function initTabs(root) {
    if (root.__nh) return; root.__nh = true;
    var tabs = [].slice.call(root.querySelectorAll('.nh-tab'));
    var panels = [].slice.call(root.querySelectorAll('.nh-panel'));
    tabs.forEach(function (tb, k) {
      tb.addEventListener('click', function () {
        tabs.forEach(function (x, j) { x.setAttribute('aria-selected', j === k ? 'true' : 'false'); x.tabIndex = j === k ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = j !== k; });
        panels[k].querySelectorAll('.nh-rv').forEach(function (e) { e.classList.add('is-in'); });
      });
      tb.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = (k + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; tabs[n].focus(); tabs[n].click();
      });
    });
  }

  function toast(html) {
    var el = document.querySelector('.nh-toast');
    if (!el) { el = document.createElement('div'); el.className = 'nh-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.innerHTML = html; el.classList.add('is-on');
    clearTimeout(el.__t); el.__t = setTimeout(function () { el.classList.remove('is-on'); }, 3500);
  }

  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form.nh-addform'); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button'); if (btn) btn.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(f.dataset.variant, 10), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        toast(f.dataset.added + ' <a href="' + f.dataset.cart + '">' + f.dataset.view + '</a>');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (n) { n.textContent = c.item_count; });
        });
      })
      .catch(function () { f.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  function initReveal() {
    if (RM || !('IntersectionObserver' in window)) return;
    var els = [].slice.call(document.querySelectorAll('.nh-rv:not(.is-in)'));
    if (!els.length) return;
    document.documentElement.classList.add('nh-motion');
    var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < innerHeight) e.classList.add('is-in'); else io.observe(e); });
  }

  function init() {
    document.querySelectorAll('.nh-hero').forEach(initHero);
    document.querySelectorAll('.nh-shop').forEach(initTabs);
    initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { var s = e.target; s.querySelectorAll('.nh-hero').forEach(function (r) { r.__nh = false; initHero(r); }); s.querySelectorAll('.nh-shop').forEach(function (r) { r.__nh = false; initTabs(r); }); initReveal(); });
})();
